module.exports = __webpack_public_path__ + "static/media/course.fb44c579.PNG";